import type { dashboardCanvasRendererProps } from '@/components/dashboard/DashboardCanvas';
import { DashboardMetricCardView } from '../../../dashboard/components/DashboardMetricCard';
import { formatDashboardPreviousPeriod } from '../../../dashboard/format';
import {
  integrationDashboardMetricTimeline,
  integrationDashboardMetricValue,
  integrationDashboardMetricLabel,
  formatIntegrationMetric,
} from './reportRequest';
import type { IntegrationDashboardRuntime } from './widgetRuntime';
import { IntegrationDashboardWidgetType, type IntegrationDashboardWidget } from './widgetModel';

export function IntegrationMetricRenderer({
  widget,
  runtime,
}: dashboardCanvasRendererProps<IntegrationDashboardWidget, IntegrationDashboardRuntime>) {
  if (widget.type !== IntegrationDashboardWidgetType.Metric) return null;
  const range = runtime.rangesByWidgetId.get(widget.id);
  const query = range ? runtime.queriesByRangeKey.get(runtime.rangeKey(range)) : undefined;
  const current = integrationDashboardMetricValue(query?.current.data, widget.metric);
  const previous = integrationDashboardMetricValue(query?.previous?.data, widget.metric);
  const label = widget.title ?? integrationDashboardMetricLabel(widget.metric);
  return (
    <DashboardMetricCardView
      label={label}
      value={formatIntegrationMetric(current, widget.metric)}
      current={current}
      previous={previous}
      comparisonPeriod={range ? formatDashboardPreviousPeriod(range) : null}
      timelineValues={integrationDashboardMetricTimeline(query?.current.data, widget.metric)}
      loading={Boolean(query?.current.isLoading)}
      error={Boolean(query?.current.isError)}
    />
  );
}
